<h2 mat-dialog-title mat-dialog-draggable-title>
  {{ "title.settings_footnote" | translate }}
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="closeDialog()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<div class="row mt-3" id="signature-dialog">
  <div class="col-12">
    <form nz-form>
      <nz-table
        #rowsTable
        nzBordered
        [nzData]="data"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        class="ant-table-no-placeholder-border-bottom"
      >
        <thead>
          <tr>
            <th class="text-center" nzWidth="55px"></th>
            <th class="text-center" nzWidth="33%">
              {{ "signature_config.name" | translate }}
            </th>
            <th class="text-center" nzWidth="33%">
              {{ "signature_config.choose_subject" | translate }}
            </th>
            <th class="text-center" nzWidth="33%">
              {{ "signature_config.page" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of rowsTable.data; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td class="text-center">
              {{
                data.signature && data.signature.name ? data.signature.name : ""
              }}
            </td>
            <td>
              <span
                class="customer-name"
                *ngIf="
                  data.signature &&
                  data.signature.object &&
                  data.signature.object === 'ENTERPRISE' &&
                  !createSide
                "
                >{{ "signature_tab.create_side" | translate }}</span
              >
              <span
                class="customer-name"
                *ngIf="
                  data.signature &&
                  data.signature.object &&
                  data.signature.object === 'ENTERPRISE' &&
                  createSide
                "
                >{{
                  createSide && createSide.name ? createSide.name : ""
                }}</span
              >
              <nz-select
                nzAllowClear
                [(ngModel)]="data.customerId"
                [ngModelOptions]="{ standalone: true }"
                class="td-nz-input"
                [nzDisabled]="!optionsCustomer.length"
                *ngIf="
                  data.signature &&
                  (!data.signature.object ||
                    data.signature.object === 'CUSTOMER')
                "
              >
                <nz-option
                  *ngFor="let option of optionsCustomer"
                  [nzLabel]="option.name"
                  [nzValue]="option.customerId"
                  [nzHide]="checkDisabledOption(option.customerId)"
                ></nz-option>
              </nz-select>
            </td>
            <td class="text-center">
              {{
                data.signature && data.signature.page ? data.signature.page : ""
              }}
            </td>
          </tr>
        </tbody>
      </nz-table>
    </form>
  </div>
</div>

<mat-divider></mat-divider>
<mat-dialog-actions align="center" class="mt-2">
  <button
    mat-stroked-button
    color="primary"
    class="mr-3"
    type="button"
    (click)="closeDialog()"
  >
    {{ "button.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" type="submit" (click)="saveData()">
    {{ "button.save" | translate }}
  </button>
</mat-dialog-actions>
